import { useState } from 'react';
import * as XLSX from 'xlsx';
import useAllActiveMarkets, { UseFetchAllActiveMarketsParams } from './useAllActiveMarkets';

/* eslint-disable @typescript-eslint/no-unused-vars */

const useExportAllActiveMarkets = (fetchAllActiveMarketsSetUp: UseFetchAllActiveMarketsParams) => {
  const [isLoading, setIsLoading] = useState(false);
  const { startFetch } = useAllActiveMarkets(fetchAllActiveMarketsSetUp);
  const exportActiveMarketsToXlsx = async () => {
    setIsLoading(true);
    const activeMarkets = await startFetch();
    const formatData = activeMarkets.map((x) => {
      return {
        Region: x.region,
        Producer: x.producer,
        'Wine name': x.wineName,
        Vintage: x.vintage,
        'Unit size': `${x?.unitCount}x${x?.unitSize}`,
        'Market value': x?.marketValue ?? '',
        Score: x?.score ?? '',
        Spread: x?.spread ?? '',
        'Highest bid': x?.highestBid?.price ?? '',
        'Lowest offer': x?.lowestOffer?.price ?? '',
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(formatData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Cultx Active Markets.xlsx');
    setIsLoading(false);
  };

  return { exportActiveMarketsToXlsx, isLoading };
};

/* eslint-enable @typescript-eslint/no-unused-vars */

export default useExportAllActiveMarkets;
